var $f090c1f8c5da0145$exports = {};
$f090c1f8c5da0145$exports = {
  "decrease": function decrease(args) {
    return "".concat(args.fieldLabel, " \uAC10\uC18C");
  },
  "increase": function increase(args) {
    return "".concat(args.fieldLabel, " \uC99D\uAC00");
  },
  "numberField": "\uBC88\uD638 \uD544\uB4DC"
};
export { $f090c1f8c5da0145$exports as default };